import { ApplicantRole, StepName, TMrpaType } from '@/types/services';
import { DocumentType } from '@/types/services';
import { isMrpaEnable } from '@/app.config';

export const StatementType = {
  NOTICE_RECOVERY: 'NOTICE_RECOVERY',
  RUZDI: 'RUZDI',
  SECURING_EVIDENCE: 'SECURING_EVIDENCE',
  TRANSFER_EL_DOCS: 'TRANSFER_EL_DOCS',

  CORRECT_TRANSLATION: 'CORRECT_TRANSLATION',
  ACCEPTANCE_DEPOSIT: 'ACCEPTANCE_DEPOSIT',
  ACCEPTANCE_ESCROW: 'ACCEPTANCE_ESCROW',
  DOCUMENT_CONVERSION: 'DOCUMENT_CONVERSION',

  STORAGE_ACCEPT: 'STORAGE_ACCEPT',
  STORAGE_ISSUE: 'STORAGE_ISSUE',
  ROD: 'ROD',
  EXTRACTION_ROD: 'EXTRACTION_ROD',

  EGRN_CONFIRM: 'EGRN_CONFIRM',
} as const;

export const RuText = {
  NO_DATA: 'Нет данных',
};

export const IdentityDocumentCode = {
  PASSPORT_RUSSIA_FEDERATION: '21',
};

export const ApplicantRoleConst: Record<ApplicantRole, ApplicantRole> = {
  APPLICANT: 'APPLICANT',
  PREVIOUS_CREDITOR: 'PREVIOUS_CREDITOR',
  CREDITOR_FROM_LIST: 'CREDITOR_FROM_LIST',
  DEBTOR: 'DEBTOR',
  DEBTOR_FROM_LIST: 'DEBTOR_FROM_LIST',
  PREVIOUS_DEBTOR: 'PREVIOUS_DEBTOR',
  TRUSTEE: 'TRUSTEE',
  ASSIGNEE: 'ASSIGNEE',
  PLEDGOR: 'PLEDGOR',
  APPLICANT_PLEGOR: 'APPLICANT_PLEGOR',
  APPLICANT_PLEDGEE: 'APPLICANT_PLEDGEE',
  APPLICANT_PLEDGE_MANAGER: 'APPLICANT_PLEDGE_MANAGER',
  NOTIFICANT: 'NOTIFICANT',
  ADDRESSEE: 'ADDRESSEE',
};

export const ErrorMessage = {
  DEFAULT: 'Непредвиденная ошибка',
};

export const PROXY_DATE_TYPE = {
  Single: 'single',
  Period: 'period',
};

export const MachineReadableFillType = {
  BY_HAND: 'byHand',
  BY_FILE: 'byFile',
  BY_GUID: 'byGUID',
};

export const TrusteeRole = {
  TRUSTEE: 'trustee',
  TRUSTEE_ORGANIZATION: 'trusteeOrganization',
};

export const MrpaType: Record<TMrpaType, TMrpaType> = {
  BY_FILE: 'BY_FILE',
  BY_GUID: 'BY_GUID',
};

export const Mask = {
  PHONE: '+7 ### ###-##-##',
  INN: '############',
  INN_ORG: '##########',
  INN_FOREIGN_ORG: '9909######',
  SNILS: '###-###-### ##',
  OGRN: '#############',
  OGRNIP: '###############',
  ACCOUNT_NUMBER: '####################',
  BIC: '#########',
};

export const FieldName = {
  obligationDocument: {
    IS_OBLIGATION_DOCUMENT: 'isObligationDocument',
  },
  CommonServiceDetailsField: {
    HAS_PRIVILEGE: 'hasPrivilege',
    NOTE: 'note',
    HAS_ANNOUNCEMENT: 'hasAnnouncement'
  },
  executiveNoticesRecoveryDetails: {
    FSSP_SUBDIVISION: 'fsspSubdivision',
    EDOC_TO_FOIV: 'edocToFoiv',
  },
  acceptanceEscrowDetails: {
    DEAL_FORM: 'dealForm',
    DEAL_INFO_DATE: 'dealInfoDate',
    DEAL_INFO_REG_NUM: 'dealInfoRegNum',
    DEAL_INFO_NOTARY_INFO: 'dealInfoNotaryInfo',
    DEPOSIT_AMOUNT: 'depositAmount',
  },
  CREDITOR_ACCOUNT_TITLE: 'creditorAccountTitle',
  CREDITOR_DETAILS_TITLE: 'creditorDetailsTitle',
  storageAcceptDetails: {
    STORAGE_PERIOD_TO: 'storagePeriodTo',
  },
  storageIssueDetails: {
    STORAGE_FILE_ID: 'storageFileId',
  },
  IS_MRPA: 'isMrpa',
  MRPA_AUTHORITY_DOCUMENT: 'mrpaAuthorityDocument',
  MRPA_BASE_AUTHORITY: 'mrpaBaseAuthority',
  MRPA_NOTARY_DOCUMENT: 'mrpaNotaryDocument',
  NAME: 'name',
  AUTHORITY_INFO: 'authorityInfo',
  ISSUE_DATE: 'issueDate',
  ISSUER: 'issuer',
  ISSUE_EXPIRATION_DATE: 'issueExpirationDate',
  ISSUE_NUMBER: 'issueNumber',
  SYSTEM_ID: 'systemId',
  REG_NUMBER: 'regNumber',
  MACHINE_READABLE: 'machineReadable',
  MACHINE_READABLE_FILL_TYPE: 'machineReadableFillType',
  ISSUE_PERIOD: 'issuePeriod',
  ISSUE_PERIOD_FROM: 'issuePeriodFrom',
  ISSUE_PERIOD_TO: 'issuePeriodTo',
  SUMMARY: 'summary',
  SNILS: 'snils',
  INN: 'inn',
  MRP_ISSUER_INN: 'mrpIssuerInn',
  OGRN: 'ogrn',
  ASSIGNEE_STATUS: 'status',
  TRUSTEE_STATUS: 'trusteeStatus',
  DOCUMENT_SERIES: 'documentSeries',
};

export const FieldLabel = {
  SNILS: 'СНИЛС',
  INN: 'ИНН',
  OGRN: 'ОГРН',
  OGRNIP: 'ОГРНИП',
  ATTESTATION: 'Сведения об удостоверении документа',
  ISSUER: 'Кем выдан',
  NOTARY_DOCUMENT_REG_NUMBER: 'Зарегистрировано в реестре: N',
  NOTARY_DOCUMENT_DOC_DATE: 'Дата регистрации',
  ASSIGNEE_STATUS: 'Должность или статус представителя',
  TRUSTEE_STATUS: 'Должность или статус представителя (при наличии)',
  APPLICANT_IS_BUSINESSMAN:
    'Заявитель является индивидуальным предпринимателем',
};

export const evidenceDocTypeToDocumentName = {
  [DocumentType.CONTRACT]: 'contractDoc',
  [DocumentType.PRELIMINARY_CONTRACT]: 'preliminaryContractDoc',
  [DocumentType.PROTECTION_PRIVATIZATION]: 'protectionPrivatizationDoc',
  [DocumentType.COMPENSATION_DAMAGE]: 'compensationDamageDoc',
  [DocumentType.LAWSUIT_RIGHTHOLDER]: 'lawsuitRightHolderDoc',
  [DocumentType.FORECLOSURE_ESTATE_RIGHTHOLDER]:
    'foreclosureEstateRightholderDoc',
  [DocumentType.OTHER_RIGHTHOLDER]: 'otherRightholder',
};

export const evidenceDocTypeToDocumentTitle = {
  [DocumentType.CONTRACT]:
    'Договор, сторонами которого являются заявитель и правообладатель или лицо, в пользу которого зарегистрированы ограничения или обременения, предметом которого  является совершение работ (оказание услуг) в отношении объекта недвижимости, принадлежащего правообладателю, или объекта недвижимости, в отношении которого в  пользу указанного лица зарегистрированы ограничения или обременения, либо передача заявителю во владение и (или) пользование такого объекта недвижимости',
  [DocumentType.PRELIMINARY_CONTRACT]:
    'Предварительный договор, сторонами которого являются заявитель и собственник объекта недвижимости, предметом которого является обязательство заключить в будущем договор об отчуждении такого объекта заявителю',
  [DocumentType.PROTECTION_PRIVATIZATION]:
    'Намерение заявителя обратиться в суд за защитой своего права на участие в приватизации объекта недвижимости',
  [DocumentType.COMPENSATION_DAMAGE]:
    'Намерение заявителя обратиться в суд за возмещением причиненного ущерба его личности или имуществу, если для возмещения такого ущерба необходимы сведения об объекте недвижимости и о его правообладателе либо о лице, в пользу которого зарегистрированы ограничения или обременения в отношении данного объекта',
  [DocumentType.LAWSUIT_RIGHTHOLDER]:
    'Наличие оснований для предъявления заявителем иска к правообладателю, в том числе предусмотренного статьями 301 и 304 Гражданского кодекса Российской Федерации, а также иска о взыскании с правообладателя объекта недвижимости либо с лица, в пользу которого зарегистрированы ограничения или обременения в отношении данного объекта, денежных средств в связи с наличием у него задолженности по уплате платежей, связанных с использованием данного объекта',
  [DocumentType.FORECLOSURE_ESTATE_RIGHTHOLDER]:
    'Наличие у заявителя предусмотренных законодательством Российской Федерации оснований для обращения взыскания на принадлежащий правообладателю на праве собственности объект недвижимости',
  [DocumentType.OTHER_RIGHTHOLDER]: 'Иное основание',
};

export const SubjectFillType = {
  MANUAL: 'manual',
  MACHINE: 'machine',
  ASSIGNEE: 'assignee',
};

export const RESEND_TO_FSSP_STEPS_COUNT = 2;

export const NoticeRecoveryStep = {
  APPLICANT: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S2
    : StepName.S1,
  CREDITORS: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S3
    : StepName.S2,
  DEBTOR: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S4
    : StepName.S3,
  DEBTORS: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S5
    : StepName.S4,
  RECOVERY_DETAILS: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S6
    : StepName.S5,
  JUDGEMENT_CREDITOR_BANK_DETAILS: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S7
    : StepName.S6,
  ACCOUNT_BANK_DETAILS: isMrpaEnable(StatementType.NOTICE_RECOVERY)
    ? StepName.S8
    : StepName.S7,
};

export const AcceptanceDepositStep = {
  DEBTOR: isMrpaEnable(StatementType.ACCEPTANCE_DEPOSIT)
    ? StepName.S2
    : StepName.S1,
  CREDITORS: isMrpaEnable(StatementType.ACCEPTANCE_DEPOSIT)
    ? StepName.S3
    : StepName.S2,
  DEPOSIT_DETAILS: isMrpaEnable(StatementType.ACCEPTANCE_DEPOSIT)
    ? StepName.S4
    : StepName.S3,
  DEBTOR_BANK_DETAILS: isMrpaEnable(StatementType.ACCEPTANCE_DEPOSIT)
    ? StepName.S5
    : StepName.S4,
  APPLICANT_BANK_DETAILS: isMrpaEnable(StatementType.ACCEPTANCE_DEPOSIT)
    ? StepName.S6
    : StepName.S5,
};

export const SecuringEvidenceStep = {
  APPLICANT: isMrpaEnable(StatementType.SECURING_EVIDENCE)
    ? StepName.S2
    : StepName.S1,
  URL: isMrpaEnable(StatementType.SECURING_EVIDENCE)
    ? StepName.S3
    : StepName.S2,
  NOTIFICANTS: isMrpaEnable(StatementType.SECURING_EVIDENCE)
    ? StepName.S4
    : StepName.S3,
  BANK_DETAILS: isMrpaEnable(StatementType.SECURING_EVIDENCE)
    ? StepName.S5
    : StepName.S4,
};

export const StorageAcceptStep = {
  APPLICANT: isMrpaEnable(StatementType.STORAGE_ACCEPT)
    ? StepName.S2
    : StepName.S1,
  STORAGE_ACCEPT_DETAILS: isMrpaEnable(StatementType.STORAGE_ACCEPT)
    ? StepName.S3
    : StepName.S2,
  BANK_DETAILS: isMrpaEnable(StatementType.STORAGE_ACCEPT)
    ? StepName.S4
    : StepName.S3,
};

export const StorageIssueStep = {
  APPLICANT: isMrpaEnable(StatementType.STORAGE_ISSUE)
    ? StepName.S2
    : StepName.S1,
  STORAGE_FILE: isMrpaEnable(StatementType.STORAGE_ISSUE)
    ? StepName.S3
    : StepName.S2,
  BANK_DETAILS: isMrpaEnable(StatementType.STORAGE_ISSUE)
    ? StepName.S4
    : StepName.S3,
};

export const CorrectTranslationStep = {
  APPLICANT: isMrpaEnable(StatementType.CORRECT_TRANSLATION)
    ? StepName.S2
    : StepName.S1,
  TRANSLATED_DOCUMENT: isMrpaEnable(StatementType.CORRECT_TRANSLATION)
    ? StepName.S3
    : StepName.S2,
  BANK_DETAILS: isMrpaEnable(StatementType.CORRECT_TRANSLATION)
    ? StepName.S4
    : StepName.S3,
};

export const TransferElDocsStep = {
  APPLICANT: isMrpaEnable(StatementType.TRANSFER_EL_DOCS)
    ? StepName.S2
    : StepName.S1,
  ADDRESSEE: isMrpaEnable(StatementType.TRANSFER_EL_DOCS)
    ? StepName.S3
    : StepName.S2,
  BANK_DETAILS: isMrpaEnable(StatementType.TRANSFER_EL_DOCS)
    ? StepName.S4
    : StepName.S3,
};

export const RuzdiStep = {
  APPLICANT: isMrpaEnable(StatementType.RUZDI) ? StepName.S2 : StepName.S1,
  EXTRACT_TYPE: isMrpaEnable(StatementType.RUZDI) ? StepName.S3 : StepName.S2,
  PLEDGOR: isMrpaEnable(StatementType.RUZDI) ? StepName.S4 : StepName.S3,
  BANK_DETAILS: isMrpaEnable(StatementType.RUZDI) ? StepName.S5 : StepName.S4,
};

export const RodStep = {
  APPLICANT: isMrpaEnable(StatementType.ROD) ? StepName.S2 : StepName.S1,
  PROXIES: isMrpaEnable(StatementType.ROD) ? StepName.S3 : StepName.S2,
};

export const ExtractionRodStep = {
  APPLICANT: isMrpaEnable(StatementType.EXTRACTION_ROD)
    ? StepName.S2
    : StepName.S1,
  PROXY_INFO: isMrpaEnable(StatementType.EXTRACTION_ROD)
    ? StepName.S3
    : StepName.S2,
  BANK_DETAILS: isMrpaEnable(StatementType.EXTRACTION_ROD)
    ? StepName.S4
    : StepName.S3,
};

export const EgrnConfirmStep = {
  APPLICANT: isMrpaEnable(StatementType.EGRN_CONFIRM)
    ? StepName.S2
    : StepName.S1,
  APPLICANT_RIGHTHOLDER: isMrpaEnable(StatementType.EGRN_CONFIRM)
    ? StepName.S4
    : StepName.S2,
  ESTATE_OBJECT: isMrpaEnable(StatementType.EGRN_CONFIRM)
    ? StepName.S5
    : StepName.S3,
  PROOF: isMrpaEnable(StatementType.EGRN_CONFIRM) ? StepName.S6 : StepName.S4,
  REFUND_DETAILS: isMrpaEnable(StatementType.EGRN_CONFIRM)
    ? StepName.S7
    : StepName.S5,
};

export const DocumentConversionStep = {
  APPLICANT: isMrpaEnable(StatementType.DOCUMENT_CONVERSION)
    ? StepName.S2
    : StepName.S1,
  CONVERSION_DOCUMENT: isMrpaEnable(StatementType.DOCUMENT_CONVERSION)
    ? StepName.S3
    : StepName.S2,
  DOCUMENT_CONVERSION_DETAILS: isMrpaEnable(StatementType.DOCUMENT_CONVERSION)
    ? StepName.S4
    : StepName.S3,
  BANK_DETAILS: isMrpaEnable(StatementType.DOCUMENT_CONVERSION)
    ? StepName.S5
    : StepName.S4,
};

export const AppEvent = {
  PARSED_MRPA_CHANGE: 'parsed-mrpa-change',
};

export const SubjectName = {
  APPLICANT: 'applicant',
  DEBTOR: 'debtor',
};

export const AdditionalStatementType = {
  ADD_DOCUMENTS: 'ADD_DOCUMENTS',
  ADD_QUITTANCES: 'ADD_QUITTANCES',
  RESEND_TO_FSSP: 'RESEND_TO_FSSP',
  WITHDRAWAL: 'WITHDRAWAL',
} as const;

export const AdditionalStatementStatus = {
  DRAFT: 'DRAFT',
  SENDING_TO_EIS: 'SENDING_TO_EIS',
  SENDING_ERROR: 'SENDING_ERROR',
  SENT_TO_EIS: 'SENT_TO_EIS',
  RECEIVED_ALT: 'RECEIVED_ALT',
  VALIDATION_ALT: 'VALIDATION_ALT',
  VALIDATION_ERROR_ALT: 'VALIDATION_ERROR_ALT',
  VALIDATION_PASSED_ALT: 'VALIDATION_PASSED_ALT',
  STATEMENT_PARSED_ALT: 'STATEMENT_PARSED_ALT',
  PROCESSED_ALT: 'PROCESSED_ALT',
  REJECTED_ALT: 'REJECTED_ALT',
  REJECTED_FOLDER_ALT: 'REJECTED_FOLDER_ALT',
  UNKNOWN: 'UNKNOWN',
} as const;

export const StatementStatus = {
  DRAFT: 'DRAFT',
  SENDING_TO_EIS: 'SENDING_TO_EIS',
  WAITING_FOR_SIGNATURES: 'WAITING_FOR_SIGNATURES',
  SENDING_ERROR: 'SENDING_ERROR',
  SENT_TO_EIS: 'SENT_TO_EIS',
  PRIMARY_VALIDATION: 'PRIMARY_VALIDATION',
  PRIMARY_VALIDATION_ROD: 'PRIMARY_VALIDATION_ROD',
  IN_QUEUE: 'IN_QUEUE',
  DISTRIBUTED: 'DISTRIBUTED',
  IN_PROGRESS: 'IN_PROGRESS',
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  PAID: 'PAID',
  PROCESSED: 'PROCESSED',
  PROCESSED_ROD: 'PROCESSED_ROD',
  SUSPENDED: 'SUSPENDED',
  REJECTED: 'REJECTED',
  ERROR: 'ERROR',
  PKUIN_ERROR: 'PKUIN_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  ENFORCEMENT_ORDER_VALIDATION_FAILED: 'ENFORCEMENT_ORDER_VALIDATION_FAILED',
  SENT_TO_FSSP: 'SENT_TO_FSSP',
  PROCESSED_FROM_FSSP: 'PROCESSED_FROM_FSSP',
  REJECTED_FROM_FSSP: 'REJECTED_FROM_FSSP',
  SUSPENDED_AWAITING_DOCUMENTS: 'SUSPENDED_AWAITING_DOCUMENTS',
  SUSPENDED_DOCUMENTS_PROVIDED: 'SUSPENDED_DOCUMENTS_PROVIDED',
  QUITTANCE_PROVIDED: 'QUITTANCE_PROVIDED',
  WITHDRAWN: 'WITHDRAWN',
  NOT_DISTRIBUTED: 'NOT_DISTRIBUTED',
  SEND_DOCUMENT: 'SEND_DOCUMENT',
  DISTRICT_UPDATED: 'DISTRICT_UPDATED',
  DOCS_TIMED_OUT: 'DOCS_TIMED_OUT',
  CERTIFICATE_PROVIDED: 'CERTIFICATE_PROVIDED',
  ISPNAD_QUITTANCE_RECEIVED: 'ISPNAD_QUITTANCE_RECEIVED',
  FSSP_ISP_DOC_RECEIVED: 'FSSP_ISP_DOC_RECEIVED',
  FSSP_ISP_DOC_RECEIVED_FAILED: 'FSSP_ISP_DOC_RECEIVED_FAILED',
  FSSP_ISP_DOC_ACCEPTED: 'FSSP_ISP_DOC_ACCEPTED',
  FSSP_ISP_DOC_ACCEPTED_FAILED: 'FSSP_ISP_DOC_ACCEPTED_FAILED',
  ISP_DOC_VALIDATION_FAILED: 'ISP_DOC_VALIDATION_FAILED',
  RETURNED: 'RETURNED',
  UNKNOWN: 'UNKNOWN',
  ACCESS_DENIED: 'ACCESS_DENIED',
  EDITED_FSSP_VALIDATION_ERROR: 'EDITED_FSSP_VALIDATION_ERROR',
  EDITED_FSSP_STATEMENT_PROVIDED: 'EDITED_FSSP_STATEMENT_PROVIDED',
  REJECTED_FOLDER: 'REJECTED_FOLDER',
  REFUSAL_PROCESSED: 'REFUSAL_PROCESSED',
  ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
  COMPLETED_FROM_FSSP: 'COMPLETED_FROM_FSSP',
  CANCELLED_FROM_FSSP: 'CANCELLED_FROM_FSSP',
  RESTARTED_FROM_FSSP: 'RESTARTED_FROM_FSSP',
  TRANSFORMED_FROM_FSSP: 'TRANSFORMED_FROM_FSSP',
  FSSP_OTHER_DOCUMENTS: 'FSSP_OTHER_DOCUMENTS',
} as const;

export const SEND_LOG_URL = 'lk/logger/sendLog';
export const GET_AUTHORIZATION_CODE_URL = 'lk/auth/getAuthorizationCode';
export const LOGOUT_URL = 'lk/auth/logout';

export const TrusteeType = {
  TRUSTEE: 'trustee',
  ASSIGNEE: 'assignee',
};

export const TrusteeLabel = {
  PERSON: 'Сведения о представителе физического лица',
  ORGANIZATION: 'Сведения о представителе юридического лица',
  FOREIGN_ORGANIZATION:
    'Сведения о представителе иностранного юридического лица',
};

export const StatementParam = {
  TH: 'УПТХ',
  TH_NEW: 'Региональный тариф',
  PRICE: 'Нотариальный тариф',
  PRICE_NEW: 'Федеральный тариф',
};

export const SubjectType = {
  APPLICANT: 'applicant',
  ASSIGNEE: 'assignee',
} as const;

export type SubjectTypeValues = typeof SubjectType[keyof typeof SubjectType];

export const OBLIGATION_TYPES = [
  {
    value: 'isEasement',
    text: 'Внесение платы за публичный сервитут в депозит нотариуса по месту нахождения земельного участка'
  },
]
